var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"missing-page",class:_vm.containClass,style:(_vm.styles)},[_vm._t("message",[_c('span',{class:_vm.messageClass},[_vm._v(_vm._s(_vm.message))])])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/iview-loader??ref--1-1!./src/views/components/missing-page.vue?vue&type=template&id=d36fe8b2&scoped=true
// module id = null
// module chunks = 